<custom-alert></custom-alert>

<section class="flex flex-column justify-content-center h-full flex-wrap align-content-center">

  <div class="app-card">
    <div class="logo my-4">
      <img src="assets/img/logo-tramitfly.png" alt="Logo tramitFly" class="img-logo"/>
      <img src="assets/img/logo-tramitfly-responsive.png" alt="Logo tramitFly" class="logo-responsive"/>
      <span class="text-black font-20 inline-flex justify-content-end font-medium">Tus trámites al instante</span>
    </div>
    <div class="flex justify-content-between pt-2 mx-auto gap-4">
      <div class="flex gap-1 align-items-center">
        <i class="pi pi-calendar" style="font-size: 1.4rem; color: var(--gray);"></i>
        <p class="text-gray my-0" style="font-size:13px"> {{ currentTime | date: 'dd/MM/YYYY' }} </p>
      </div>
      <div class="flex gap-1 align-items-center">
        <i class="pi pi-clock text-gray" style="font-size: 1.4rem;"></i>
        <p class="text-gray my-0" style="font-size:13px"> {{ currentTime | date: 'HH:mm' }} </p>
      </div>
      <div class="flex gap-1 align-items-center">
        <i class="pi pi-globe text-gray" style="font-size: 1.4rem;"></i>
        <p class="text-gray my-0" style="font-size:11px"> {{ location }} </p>
      </div>
    </div>
    <div class="flex justify-content-center flex-column align-items-center mb-5">
      <h3 class="font-bold mt-4 color-blue-2 " style="font-size:1.7rem;">{{ translations.welcome }}</h3>
      <h6 class="font-normal color-blue-2 my-0" style="font-size:1.3rem;">{{translations.message}}</h6>
    </div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="w-full">
      <div class="flex flex-column gap-2 mt-2">
        <main class="grid formgrid p-fluid">
          <div class="field col-12 ">
            <div class="inline-flex align-items-center  input-wrapper pl-3 w-full">
              <i class="pi pi-user label-form"></i>
            <input pInputText class=" w-full ml-2 border-0 label-form font-normal" [placeholder]="translations.correo"
                   formControlName="correo" id="correo" type="text" style="width: 100%"/>
            </div>
            <ng-container *ngIf="form.get('correo')?.invalid && form.get('correo')?.touched">
              <app-form-group-error-message [control]="form.get('correo')"></app-form-group-error-message>
            </ng-container>
          </div>
          <div class="field col-12 mt-3">
            <div class="flex justify-content-center">
              <button pButton type="submit" [label]="translations.restablecerButton" class="tax-app-button w-fit px-5"
                      style="width: 20rem;"></button>
            </div>
          </div>
          <div class="field col-12 ">
            <a class="flex gap-3 align-items-center label-form-sidebar justify-content-center
   cursor-pointer container-width-sidebar color-secondary " (click)="onBack()">
              <span class="  my-0 font-normal "> {{translations.atras}} </span>
            </a>
          </div>
        </main>
      </div>
    </form>
  </div>
</section>
